import { render, staticRenderFns } from "./MediaGallery.vue?vue&type=template&id=65be3f49&scoped=true"
import script from "./MediaGallery.vue?vue&type=script&lang=js"
export * from "./MediaGallery.vue?vue&type=script&lang=js"
import style0 from "./MediaGallery.vue?vue&type=style&index=0&id=65be3f49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65be3f49",
  null
  
)

export default component.exports